import type { MaturityCorrection, QualityData } from '../types/domain';

function roundToOneDecimal(value: number): number {
    return Math.round(value * 10) / 10;
}

function isFiniteNumber(value: unknown): value is number {
    return typeof value === 'number' && Number.isFinite(value);
}

/**
 * The API types the field as optional, but JSON can still carry `null`, so anything that is not
 * a finite number means "no correction for this report" rather than a render error.
 */
export function mapMaturityCorrection(
    woundPct: unknown,
    maturityPct: unknown
): MaturityCorrection | undefined {
    if (!isFiniteNumber(woundPct) || !isFiniteNumber(maturityPct)) {
        return undefined;
    }

    const roundedWoundPct = roundToOneDecimal(Math.max(0, woundPct));
    let roundedMaturityPct = roundToOneDecimal(Math.max(0, maturityPct));
    // Legend and donut read these values, so they must sum to at most 100.
    if (roundedWoundPct + roundedMaturityPct > 100) {
        roundedMaturityPct = roundToOneDecimal(Math.max(0, 100 - roundedWoundPct));
    }

    return {
        woundPct: roundedWoundPct,
        maturityPct: roundedMaturityPct,
        totalPct: roundToOneDecimal(roundedWoundPct + roundedMaturityPct),
        isApplied: maturityPct > 0,
    };
}

/** The PDF is shared with customers, so its copy of the quality data must not carry this. */
export function withoutMaturityCorrection(
    qualityData: QualityData | undefined
): QualityData | undefined {
    if (!qualityData) {
        return undefined;
    }

    const { maturityCorrection: _internalOnly, ...customerFacing } = qualityData;
    return customerFacing;
}
